import Devices from './Devices';
import { Host } from '../../models';

class Hosts extends Devices {
    constructor() {
        super({
            model: Host,
            entryPoint: 'hosts',
            resource: 'host',
            resources: 'hosts',
            idField: '_id'
        });
    }
}

const HostsApi = new Hosts();

export default HostsApi;
